import { createContext, useContext } from "react";

import { PlayerFormValues } from "../types";

interface PlayerContextInterface {
  playerIdToRetrieve: string;
  setPlayerIdToRetrieve: (value: string | ((prev: string) => string)) => void;
  playerFormValues: PlayerFormValues;
  setPlayerFormValues: (
    value: PlayerFormValues | ((prev: PlayerFormValues) => PlayerFormValues),
  ) => void;
}

const emptyPlayerFormValues: PlayerFormValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: null,
  throws: { value: "", label: "" },
  hits: { value: "", label: "" },
  heightFeet: "",
  heightInches: "",
  weight: "",
  orgPlayerId: "",
  officialLeagueId: "",
};

const defaultPlayerState = {
  playerIdToRetrieve: "",
  setPlayerIdToRetrieve: (): string => "",
  playerFormValues: emptyPlayerFormValues,
  setPlayerFormValues: (): PlayerFormValues => emptyPlayerFormValues,
};

const PlayerContext = createContext<PlayerContextInterface>(defaultPlayerState);

export const usePlayerContext = (): PlayerContextInterface =>
  useContext(PlayerContext);

export default PlayerContext;
